import { render, staticRenderFns } from "./EditCategory.vue?vue&type=template&id=8f133504&scoped=true"
import script from "./EditCategory.vue?vue&type=script&lang=js"
export * from "./EditCategory.vue?vue&type=script&lang=js"
import style0 from "./EditCategory.vue?vue&type=style&index=0&id=8f133504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f133504",
  null
  
)

export default component.exports